import * as React from 'react';

import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import { IconContainer } from './styles';

export default function CategoryCard({ Icon, label, onClick }) {
  return (
    <Card variant="outlined">
      <CardActionArea onClick={onClick} sx={{ display: 'flex' }}>
        <CardContent>
          <Typography variant="h5">{label}</Typography>
        </CardContent>
        <IconContainer>
          <Icon fontSize='large' />
        </IconContainer>
      </CardActionArea>
    </Card>
  );
}
